import React from 'react';

export function Section({
  icon,
  title,
  subtitle,
  action,
  children,
  className = '',
  dense = false,
}) {
  const pad = dense ? 'p-4' : 'p-4 sm:p-5';
  const gap = dense ? 'mb-3' : 'mb-4';
  return (
    <section className={`cwp-surface-card ${pad} ${className}`}>
      <header className={`flex flex-wrap items-center justify-between gap-3 ${gap}`}>
        <div className="flex min-w-0 items-center gap-2.5">
          {icon ? (
            <span className="cwp-icon-tile flex h-7 w-7 shrink-0 items-center justify-center [&>svg]:h-3.5 [&>svg]:w-3.5">
              {icon}
            </span>
          ) : null}
          <div className="min-w-0">
            <h2 className="text-[13.5px] font-semibold leading-tight tracking-tight text-slate-900">{title}</h2>
            {subtitle ? (
              <p className="mt-0.5 text-[11px] leading-tight text-slate-500">{subtitle}</p>
            ) : null}
          </div>
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </header>
      {children}
    </section>
  );
}

export function Field({ label, value, mono, className = '' }) {
  return (
    <div
      className={`rounded-lg p-2.5 transition hover:border-slate-300 ${className}`}
      style={{
        background: 'var(--cwp-card-muted)',
        border: '1px solid var(--cwp-border)',
      }}
    >
      <div className="cwp-label-eyebrow mb-1">{label}</div>
      <div
        className={`text-[13px] font-medium leading-snug text-slate-900 ${mono ? 'font-mono text-[12.5px]' : ''}`}
      >
        {value}
      </div>
    </div>
  );
}

const tonePalette = {
  info: {
    bg: 'oklch(0.95 0.05 235 / 0.6)',
    fg: 'oklch(0.35 0.14 235)',
    dot: 'oklch(0.62 0.15 235)',
  },
  success: {
    bg: 'oklch(0.94 0.08 155 / 0.6)',
    fg: 'oklch(0.3 0.1 155)',
    dot: 'oklch(0.66 0.15 155)',
  },
  warning: {
    bg: 'oklch(0.96 0.1 80 / 0.6)',
    fg: 'oklch(0.4 0.1 75)',
    dot: 'oklch(0.78 0.14 75)',
  },
};

export function StatusBadge({ children, tone = 'info' }) {
  const p = tonePalette[tone] || tonePalette.info;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11.5px] font-semibold tracking-tight"
      style={{
        background: p.bg,
        color: p.fg,
        border: `1px solid ${p.dot}33`,
      }}
    >
      <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ background: p.dot }} aria-hidden />
      {children}
    </span>
  );
}
